import { render, staticRenderFns } from "./routeBus.vue?vue&type=template&id=1dbc15ff&"
import script from "./routeBus.vue?vue&type=script&lang=js&"
export * from "./routeBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports